<template>
    <div data-component="KitchenOrderDetailsTable"
         class="kitchen-order-details-table">
        <table class="table">
            <tbody>
                <KitchenOrderDetailsItemRow v-for="item in currentItems"
                                            :key="item.key"
                                            :item="item" />
            </tbody>
        </table>
    </div>
</template>

<script>
import KitchenOrderDetailsItemRow from './KitchenOrderDetailsItemRow';

export default {
    components: {
        KitchenOrderDetailsItemRow,
    },

    props: {
        /**
         * @type {KitchenOrderItem[]}
         */
        currentItems: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="less">
@import (less, reference) "../../../less/variables.less";

.kitchen-order-details-table {
    border: 1px solid @btn-default-border;
    border-top: 0;
    box-shadow: 0 3px 8px -9px black;
    border-radius: @border-radius-base;

    &__qty-cell {
        width: 1px;
    }

    &__fields {
        margin: 0;
        padding: 0 0 0 30px;
        list-style-type: square;

        li > span {
            display: block;
        }
    }

    .stand-out-text {
        font-weight: bold;
        color: @brand-danger;
    }
}

</style>
